var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.884 15.167c-.536 0-.984-.167-1.344-.5-.36-.335-.54-.752-.54-1.25V1.75C0 1.25.18.835.54.502.9.167 1.347 0 1.884 0h17.232c.537 0 .985.167 1.344.502.36.333.54.75.54 1.248v11.667c0 .498-.18.914-.539 1.248-.36.335-.808.502-1.345.502H1.884zm8.616-7.46l9.333-5.665-.359-.959L10.5 6.5 1.526 1.083l-.36.96L10.5 7.707z",
    fill: "#FEDF00"
  })));
}

export default SvgMail;